module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay-news"
  }, [_c('div', {
    staticClass: "overlay-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "border-grid"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.cookie_title'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.cookie_text'))
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355a1810","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cookie.vue
// module id = 379
// module chunks = 0